jQuery(function($) {
  $(document).ready(function () {

    /* banner text */
    var t = $('.banner-title').find('a').text();
    $('.banner-title h1').find('b').html(t);
    if (!t) {
      $('.banner-title h1').find('b').html($('.page-title').text());
    }
    /* Mobile naviagtion */
    $('#navTrigger').click(function () {
      $('#navTrigger,.mobile-nav, html').toggleClass('active');
    });
    /* home page down arrow */
    $('#gotoSection').click(function (e) {
      e.preventDefault();
      var top = $('#range').offset().top - 80;
      $("html, body").animate({scrollTop: top}, 600);
      return false;
    });
    /* navigation classes */
    $('.navigation li.level-1:first').addClass('first');
    $('.navigation li.level-1:last').addClass('last');
    $('.navigation li.level-1').children('ul').each(function () {
      $(this).children('li:last').addClass('last');
    });
    $('.navigation li.active').parents('ul.menu').siblings('a').removeClass('starter_normal').addClass('starter_active').parent().removeClass('starter_normal').addClass('starter_active');
    if ($('#subnavigation li.level-2').length == 0) {
      $('#subnavigation').hide();
    }
    $('#subnavigation li.active').parents('ul.menu').siblings('a').removeClass('inactive').addClass('active').parent().removeClass('inactive').addClass('active');
    if ($('#subnavigation li.level-2:visible:last ul:visible').length == 0) {
      $('#subnavigation li.level-2 > a:visible:last').addClass('no-border');
    }
    if ($('#subnavigation li:visible:last').hasClass('level-3')) {
      $('#subnavigation li:visible:last').parent().addClass('no-border');
    }
    if ($('#subnavigation li:visible:last').hasClass('level-4')) {
      $('#subnavigation li:visible:last').parent().parent().parent().addClass('no-border');
    }

    //contact form label as placeholder
    $('#contactForm').find('.form-group').each(function () {
      var fieldId = $(this).find('label').attr('for');
      if (fieldId) {
        var value = $(this).find('label').text();
        $('#' + fieldId).attr('placeholder', $(this).find('label').text());
        $(this).find('label').remove();
      }
    });

    $(window).scroll(function () {
      if ($(this).scrollTop() > 80) {
        $(".header").addClass('scrolled');
        $("#top-logo").addClass('scrolled');
      }
      else {
        $(".header").removeClass('scrolled');
        $("#top-logo").removeClass('scrolled');
      }

    });
  });

  $(window).load(function () {
    var slider = $("#homepage-hero");
    $('#homeSlider img').each(function () {
      var slideDiv = $('<div />').addClass('slide');
      var img = $('<img />').attr({class: "lazyOwl", 'data-src': $(this).attr('src'), alt: $(this).attr('alt')});
      img.appendTo(slideDiv);
      //slider.data('owlCarousel').addItem(slideDiv);
      slider.append(slideDiv);

    });


    /* site loader */
    $('#preloader').hide();
  });
});

